module.exports = __webpack_public_path__ + "static/img/trial.7bc3030.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/trial.png
// module id = EX2t
// module chunks = 1